import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.rules.query.gql"
import type {
  FeatureGroupRulesQuery,
  FeatureGroupRulesQueryVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.rules.query"

type Options = QueryHookOptions<
  FeatureGroupRulesQuery,
  FeatureGroupRulesQueryVariables
>

export function useFeatureGroupRulesQuery(options?: Options) {
  return useQuery<FeatureGroupRulesQuery, FeatureGroupRulesQueryVariables>(
    query,
    options,
  )
}
